<button
  ejs-dropdownbutton
  cssClass="e-flat"
  [items]="languages"
  iconCss="fas fa-globe"
  (select)="selectLanguage($event)"
  [content]="selectedLanguage.text | translate"
></button>
